<template>
    <Component :is="sliceVariationComponent" v-bind="props" />
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {PricingSlice} from '@prismicio-types';
    import PricingDefault from './variations/PricingDefault.vue';
    import PricingDetailed from './variations/PricingDetailed.vue';
    import {getSliceVariationComponent} from '../../utils/sliceVariations';

    const props = defineProps(getSliceComponentProps<PricingSlice>(['slice', 'index', 'slices', 'context']));

    const variationComponents = {
        default: PricingDefault,
        pricingDetailed: PricingDetailed,
    };

    const sliceVariationComponent = computed(() => getSliceVariationComponent(props.slice, variationComponents));
</script>
